import React from 'react'

import { connect } from 'react-redux'

import BasePureComponent from 'utils/BasePureComponent'
import VehicleDataStep from './VehicleDataStep'
import PolicyDataStep from './PolicyDataStep'
import DocumentsStep from './DocumentsStep'
import DriversDataStep from './DriversDataStep'

import StepIndicator from './StepIndicator'

import { changeStep } from './actions'

import './style.scss'

const STEP_COMPONENTS = [
  VehicleDataStep,
  PolicyDataStep,
  DocumentsStep,
  DriversDataStep
]

export class AddVehicleModal extends BasePureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const StepComponent = STEP_COMPONENTS[this.props.currentStep]

    return (
      <section id="AddVehicleModal" className="AddVehicleModal">
        <div className="AddVehicleModal__header">
          <h6>Crear nueva poliza</h6>
        </div>
        <div className="AddVehicleModal__step-indicator">
          <StepIndicator
            step={1}
            iconName="directions_car"
            name="Vehículo"
          />
          <StepIndicator
            step={2}
            iconName="security"
            name="Póliza de seguro"
          />
          <StepIndicator
            step={3}
            iconName="folder"
            name="Documentos"
          />
          <StepIndicator
            step={4}
            iconName="people"
            name="Conductores"
          />
        </div>
        <div className="AddVehicleModal__body">
          <div className="AddVehicleModal__body-wrapper">
            <StepComponent
              clientId={this.props.match.params.id}
            />
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentStep: parseInt(state.addVehicleModal.get('currentStep'), 10),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeStep: (step) => dispatch(changeStep(step)),
    dispatch
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddVehicleModal)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AddVehicleModal/index.js